import React from 'react';

const PrintYourCause = () => <h1>PrintYourCause</h1>;

export default PrintYourCause;
